const f = {
  palette: {
    mode: "light",
    primary: {
      main: "#191919ff",
      contrastText: "#ffffffff"
    },
    secondary: {
      main: "#ffffffff",
      contrastText: "#191919ff"
    },
    error: {
      main: "#be2434ff",
      contrastText: "#191919ff",
      light: "#f2c9c6ff",
      dark: "#be2434ff"
    },
    warning: {
      main: "#c0570dff",
      contrastText: "#191919ff",
      light: "#f4ead2ff",
      dark: "#c0570dff"
    },
    info: {
      main: "#015e8dff",
      light: "#cbebfaff",
      contrastText: "#191919ff",
      dark: "#015e8dff"
    },
    success: {
      main: "#358600ff",
      contrastText: "#191919ff",
      light: "#e8f3edff",
      dark: "#358600ff"
    },
    grey: {
      10: "#f9f9f9ff",
      15: "#eaeaeaff",
      20: "#dbdbdbff",
      30: "#c6c6c6ff",
      40: "#a9a9a9ff",
      50: "#909090ff",
      100: "#7b7b7bff",
      200: "#565656ff",
      300: "#3f3f3fff",
      400: "#363636ff",
      500: "#2d2d2dff",
      600: "#272727ff",
      700: "#1e1e1eff",
      800: "#191919ff",
      900: "#101010ff",
      white: "#ffffffff",
      black: "#000000ff"
    },
    text: {
      primary: "#191919ff",
      secondary: "#909090ff",
      disabled: "#909090ff"
    },
    action: {
      disabled: "#909090ff",
      disabledBackground: "#eaeaeaff"
    }
  },
  themeKey: "atriuslight",
  mode: "light",
  color: {
    red: {
      50: "#fbe4e3ff",
      100: "#f2c9c6ff",
      200: "#f3a6a2ff",
      300: "#f98480ff",
      400: "#fb6265ff",
      500: "#ff424fff",
      600: "#f33c49ff",
      700: "#e63745ff",
      800: "#e02f3eff",
      900: "#be2434ff",
      a100: "#cc1414ff",
      a200: "#8f0000ff",
      a300: "#650000ff"
    },
    green: {
      50: "#f0f7f3ff",
      100: "#e8f3edff",
      200: "#d9f1cbff",
      300: "#c2e6aaff",
      400: "#a7d987ff",
      500: "#8dce61ff",
      600: "#79c542ff",
      700: "#63bc1fff",
      800: "#52ab15ff",
      900: "#358600ff",
      a100: "#2c8500ff",
      a200: "#006300ff",
      a400: "#007239ff",
      a500: "#004d32ff"
    },
    blue: {
      50: "#e1f4feff",
      100: "#cbebfaff",
      200: "#91d9fdff",
      300: "#4dc0f5ff",
      400: "#26b2f4ff",
      500: "#0098e2ff",
      600: "#0085c6ff",
      700: "#0173baff",
      800: "#00679bff",
      900: "#015e8dff",
      a100: "#b4cbdfff",
      a50: "#ebf4f8ff"
    },
    gray: {
      10: "#f9f9f9ff",
      15: "#eaeaeaff",
      20: "#dbdbdbff",
      30: "#c6c6c6ff",
      40: "#a9a9a9ff",
      50: "#909090ff",
      100: "#7b7b7bff",
      200: "#565656ff",
      300: "#3f3f3fff",
      400: "#363636ff",
      500: "#2d2d2dff",
      600: "#272727ff",
      700: "#1e1e1eff",
      800: "#191919ff",
      900: "#101010ff",
      white: "#ffffffff",
      black: "#000000ff"
    },
    avatar: {
      avataryellow100: "#f1c40fff",
      avataryellow200: "#f39c12ff",
      avataryellow300: "#e67e22ff",
      avataryellow400: "#d35400ff",
      avatarred100: "#e74c3cff",
      avatarred200: "#c0392bff",
      avatarred300: "#a20025ff",
      avatarpink100: "#f472d0ff",
      avatarpink200: "#d80073ff",
      avatarpurple100: "#9b59b6ff",
      avatarpurple200: "#8e44adff",
      avatarpurple300: "#6a00ffff",
      avatarblue100: "#3498dbff",
      avatarblue200: "#2980b9ff",
      avatarblue300: "#0050efff",
      avatarblue400: "#2c3e50ff",
      avatargreen100: "#1abc9cff",
      avatargreen200: "#16a085ff",
      avatargreen300: "#2ecc71ff",
      avatargreen400: "#27ae60ff"
    },
    yellow: {
      50: "#f9f2e3ff",
      100: "#f4ead2ff",
      200: "#efd79fff",
      300: "#ebc36bff",
      400: "#eab448ff",
      500: "#eba832ff",
      600: "#e79d2dff",
      700: "#e28f29ff",
      800: "#dc8024ff",
      900: "#c0570dff"
    },
    marketing: {
      distech: {
        green: {
          100: "#62bb4633",
          200: "#62bb4666",
          300: "#62bb4680",
          400: "#62bb4699",
          500: "#62bb46cc",
          600: "#62bb46e6",
          700: "#62bb46ff"
        },
        blue: {
          100: "#009ada33",
          200: "#009ada66",
          300: "#009ada80",
          400: "#009ada99",
          500: "#009adacc",
          600: "#009adae6",
          700: "#009adaff"
        },
        navy: {
          100: "#0d2d6c33",
          200: "#0d2d6c66",
          300: "#0d2d6c80",
          400: "#0d2d6c99",
          500: "#0d2d6ccc",
          600: "#0d2d6ce6",
          700: "#0d2d6cff"
        },
        gray: {
          100: "#474c5533",
          200: "#474c5566",
          300: "#474c5580",
          400: "#474c5599",
          500: "#474c55cc",
          600: "#474c55e6",
          700: "#474c55ff"
        }
      }
    },
    navy: {
      50: "#ecedf0ff",
      100: "#ced4d9ff",
      200: "#a5b3beff",
      300: "#8d9ba8ff",
      400: "#698093ff",
      500: "#5e7284ff",
      600: "#516373ff",
      700: "#485865ff",
      800: "#3c4a55ff",
      900: "#333e48ff",
      a100: "#242c33ff",
      a200: "#1d2228ff"
    },
    purple: {
      50: "#f2f0fbff",
      100: "#eee9faff",
      200: "#d3c9f2ff",
      300: "#b6a6eaff",
      400: "#9781e2ff",
      500: "#7f65dbff",
      600: "#674bd2ff",
      700: "#5c45ccff",
      800: "#4d3dc2ff",
      900: "#3f37baff",
      a100: "#262cabff"
    },
    teal: {
      50: "#dff2f0ff",
      100: "#b0e0d7ff",
      200: "#7bccbeff",
      300: "#43b7a4ff",
      400: "#03a792ff",
      500: "#00977fff",
      600: "#008a72ff",
      700: "#007a63ff",
      800: "#006a54ff",
      900: "#004e39ff"
    },
    pink: {
      50: "#fbe5f0ff",
      100: "#f6bedaff",
      200: "#f295c2ff",
      300: "#f06aa8ff",
      400: "#ee4a94ff",
      500: "#ee2c7fff",
      600: "#dc2a79ff",
      700: "#c52873ff",
      800: "#af256dff",
      900: "#882062ff"
    },
    brand: {
      dln: {
        green: {
          20: "#d9ece1ff",
          30: "#ddffd0ff",
          50: "#a7f7b8ff",
          100: "#409f68ff",
          300: "#004d32ff",
          400: "#283b2cff",
          500: "#2c342dff"
        },
        blue: {
          10: "#d4fbfbff",
          30: "#a9f6f8ff",
          50: "#64d9dbff",
          100: "#b4cbdfff",
          200: "#0076a7ff",
          300: "#47606bff",
          400: "#004d7aff",
          500: "#003854ff",
          600: "#3a454bff"
        }
      }
    },
    text: {
      highemphasis: "#191919ff",
      midemphasis: "#565656ff",
      error: "#be2434ff",
      primary: "#ffffffff",
      disabled: "#909090ff",
      lowemphasis: "#909090ff",
      primaryhover: "#ffffffff",
      primaryselected: "#ffffffff",
      secondary: "#191919ff",
      secondaryhover: "#565656ff",
      secondaryselected: "#363636ff",
      tertiary: "#191919ff",
      tertiaryhover: "#565656ff",
      tertiaryselected: "#363636ff",
      staticblackinverted: "#191919ff",
      staticblackinvertedhover: "#191919ff",
      staticblackinvertedselected: "#191919ff",
      staticwhite: "#ffffffff",
      staticwhitehover: "#ffffffff",
      staticwhiteselected: "#ffffffff",
      staticwhiteinverted: "#ffffffff",
      staticwhiteinvertedhover: "#ffffffff",
      staticwhiteinvertedselected: "#ffffffff",
      staticblack: "#191919ff",
      staticblackhover: "#191919ff",
      staticblackselected: "#191919ff"
    },
    background: {
      surface: "#ffffffff",
      input: "#f9f9f9ff",
      primary: "#191919ff",
      infolight: "#cbebfaff",
      successlight: "#e8f3edff",
      errorlight: "#f2c9c6ff",
      warninglight: "#f4ead2ff",
      disabled: "#eaeaeaff",
      surfacehover: "#eaeaeaff",
      surfaceselected: "#dbdbdbff",
      primaryhover: "#565656ff",
      primaryselected: "#363636ff",
      background: "#ffffffff",
      secondary: "#ffffffff",
      secondaryhover: "#eaeaeaff",
      secondaryselected: "#dbdbdbff",
      tertiaryhover: "#eaeaeaff",
      tertiary: "#ffffffff",
      tertiaryselected: "#dbdbdbff",
      staticblackinverted: "#191919ff",
      staticblackinvertedhover: "#565656ff",
      staticblackinvertedselected: "#363636ff",
      info: "#015e8dff",
      success: "#358600ff",
      warning: "#c0570dff",
      error: "#be2434ff",
      errorhover: "#e02f3eff",
      errorselected: "#e63745ff",
      staticwhite: "#ffffffff",
      staticwhitehover: "#eaeaeaff",
      staticwhiteselected: "#dbdbdbff",
      container: "#f9f9f9ff",
      surfacealt: "#f9f9f9ff",
      staticblack: "#191919ff",
      staticblackhover: "#565656ff",
      staticblackselected: "#363636ff",
      staticwhiteinverted: "#ffffffff",
      statictransparentwhitehover: "#ffffff26",
      statictransparentwhiteselected: "#ffffff40",
      staticwhiteinvertedhover: "#eaeaeaff",
      staticwhiteinvertedselected: "#dbdbdbff",
      statictransparentblackhover: "#19191926",
      statictransparentblackselected: "#19191940"
    },
    border: {
      surface: "#dbdbdbff",
      info: "#015e8dff",
      error: "#be2434ff",
      warning: "#c0570dff",
      success: "#358600ff",
      disabled: "#909090ff",
      secondary: "#191919ff",
      focus: "#19191980",
      secondaryhover: "#565656ff",
      secondaryselected: "#363636ff",
      highemphasis: "#191919ff",
      midemphasis: "#565656ff",
      lowemphasis: "#909090ff",
      surfacehover: "#565656ff",
      surfaceselected: "#191919ff",
      primary: "#ffffffff",
      primaryhover: "#ffffffff",
      primaryselected: "#ffffffff",
      tertiary: "#191919ff",
      tertiaryhover: "#565656ff",
      tertiaryselected: "#363636ff",
      staticblackinverted: "#191919ff",
      staticblackinvertedhover: "#191919ff",
      staticblackinvertedselected: "#191919ff",
      staticwhite: "#ffffffff",
      staticwhitehover: "#ffffffff",
      staticwhiteselected: "#ffffffff",
      staticblack: "#191919ff",
      staticblackhover: "#191919ff",
      staticblackselected: "#191919ff",
      staticwhiteinverted: "#ffffffff",
      staticwhiteinvertedhover: "#ffffffff",
      staticwhiteinvertedselected: "#ffffffff"
    },
    element: {
      secondary: "#191919ff",
      highemphasis: "#191919ff",
      info: "#015e8dff",
      success: "#358600ff",
      error: "#be2434ff",
      warning: "#c0570dff",
      primary: "#ffffffff",
      disabled: "#909090ff",
      secondaryhover: "#565656ff",
      secondaryselected: "#363636ff",
      midemphasis: "#565656ff",
      lowemphasis: "#909090ff",
      primaryhover: "#ffffffff",
      primaryselected: "#ffffffff",
      tertiary: "#191919ff",
      tertiaryhover: "#565656ff",
      tertiaryselected: "#363636ff",
      staticblackinverted: "#191919ff",
      staticblackinvertedhover: "#191919ff",
      staticblackinvertedselected: "#191919ff",
      iconbutton: "#565656ff",
      iconbuttonhover: "#363636ff",
      iconbuttonselected: "#191919ff",
      staticwhite: "#ffffffff",
      staticwhitehover: "#ffffffff",
      staticwhiteselected: "#ffffffff",
      staticblack: "#191919ff",
      staticblackhover: "#191919ff",
      staticblackselected: "#191919ff",
      staticwhiteinverted: "#ffffffff",
      staticwhiteinvertedhover: "#ffffffff",
      staticwhiteinvertedselected: "#ffffffff"
    },
    scrim: {
      heavy: "#2d2d2d99",
      light100: "#ffffffff",
      light60: "#ffffff99",
      light30: "#ffffff4d"
    }
  },
  size: {
    0: "0px",
    25: "1px",
    50: "2px",
    100: "4px",
    150: "6px",
    200: "8px",
    250: "10px",
    300: "12px",
    350: "14px",
    400: "16px",
    450: "18px",
    500: "20px",
    550: "22px",
    600: "24px",
    700: "28px",
    800: "32px",
    900: "36px",
    1e3: "40px",
    1100: "44px",
    1200: "48px",
    1500: "60px",
    1600: "64px",
    1800: "72px",
    2e3: "80px",
    2400: "96px",
    3e3: "120px",
    3600: "144px",
    7e3: "280px",
    size7500: "300px"
  },
  radius: {
    0: "0px",
    200: "2px",
    400: "4px",
    600: "6px",
    800: "8px",
    1600: "16px",
    3600: "36px",
    4800: "48px",
    circle: "9999px",
    small: "4px",
    medium: "8px",
    large: "16px"
  },
  borderwidth: {
    200: "2px",
    400: "4px",
    600: "6px",
    default: "1px",
    hover: "2px",
    focus: "4px",
    selected: "2px"
  },
  padding: {
    typography: {
      titleparagraph: "20px",
      paragraphparagraph: "48px",
      paragraphsubtext: "16px"
    }
  },
  component: {
    chip: {
      color: {
        border: {
          primary: "#191919ff",
          red: "#be2434ff",
          yellow: "#c0570dff",
          green: "#358600ff",
          blue: "#015e8dff",
          navy: "#333e48ff",
          purple: "#3f37baff",
          teal: "#004e39ff",
          pink: "#882062ff",
          gray: "#191919ff"
        },
        element: {
          blue: "#015e8dff",
          red: "#be2434ff",
          green: "#358600ff",
          yellow: "#c0570dff",
          purple: "#3f37baff",
          gray: "#101010ff",
          navy: "#333e48ff",
          teal: "#004e39ff",
          pink: "#882062ff"
        }
      }
    },
    listitem: {
      color: {
        iconborder: "#d97d29ff",
        iconselected: "#d97d29ff",
        iconselectedhover: "#d4751dff"
      }
    },
    colorswatch: {
      color: {
        checkmark: {
          primary: "#ffffffff"
        },
        element: {
          static: "#000000ff"
        },
        grayscale: {
          white: "#ffffffff",
          lightgray: "#909090ff",
          darkgray: "#565656ff",
          black: "#000000ff"
        }
      }
    },
    avatar: {
      color: {
        background: {
          primary: "#16a085ff",
          avataryellow1: "#f1c40fff",
          avataryellow2: "#f39c12ff",
          avataryellow3: "#e67e22ff",
          avataryellow4: "#d35400ff",
          avatarred1: "#e74c3cff",
          avatarred2: "#c0392bff",
          avatarred3: "#a20025ff",
          avatarpink1: "#f472d0ff",
          avatarpink2: "#d80073ff",
          avatarpurple1: "#9b59b6ff",
          avatarpurpel2: "#8e44adff",
          avatarpurple3: "#6a00ffff",
          avatarblue1: "#3498dbff",
          avatarblue2: "#2980b9ff",
          avatarblue3: "#0050efff",
          avatarblue4: "#2c3e50ff",
          avatargreen1: "#1abc9cff",
          avatargreen2: "#16a085ff",
          avatargreen3: "#2ecc71ff",
          avatargreen4: "#27ae60ff"
        },
        border: {
          hover: "#565656ff",
          selected: "#363636ff"
        }
      }
    },
    modal: {
      padding: {
        top: "24px",
        right: "24px",
        bottom: "24px",
        left: "24px",
        titletext: "20px",
        titlebanner: "16px",
        titletile: "32px",
        titletilebutton: "60px",
        textbutton: "32px"
      }
    },
    section: {
      padding: {
        top: "32px",
        bottom: "32px"
      }
    },
    sheet: {
      padding: {
        regulartop: "72px",
        regularright: "24px",
        regularbottom: "0px",
        regularleft: "24px",
        compacttop: "20px",
        compactright: "20px",
        compactbottom: "0px",
        compactleft: "20px"
      }
    },
    toast: {
      color: {
        background: {
          general: "#3f3f3fff"
        }
      }
    },
    progress: {
      color: {
        border: {
          tertiary: "#909090ff",
          primarydeterminate: "#191919ff",
          primaryindeterminate: "#191919ff"
        },
        element: {
          primary: "#191919ff"
        }
      }
    },
    sidemenu: {
      color: {
        background: {
          surfaceselected: "#dbdbdbff",
          surfacehover: "#eaeaeaff"
        }
      }
    },
    a50: "#dae5efff",
    banner: {
      color: {
        icon: {
          info: "#015e8dff",
          success: "#358600ff",
          warning: "#c0570dff",
          error: "#be2434ff"
        }
      }
    },
    static: "#ffffffff",
    textfield: {
      color: {
        element: {
          secondary: "#7b7b7bff"
        }
      }
    },
    switch: {
      color: {
        background: {
          primaryhover: "#565656ff",
          primary: "#c6c6c6ff"
        }
      },
      borderwidth: {
        focus: "6px"
      }
    },
    scrollbar: {
      color: {
        backround: "#f9f9f9ff",
        border: "#dbdbdbff",
        arrowbuttons: "#a9a9a9ff",
        thumb: "#a9a9a9ff"
      }
    }
  },
  typography: {
    body1: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: 1.7142,
      letterSpacing: "normal"
    },
    body2: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: 1.3,
      letterSpacing: "normal"
    },
    button: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 500,
      fontSize: "0.875rem",
      lineHeight: 1.3,
      letterSpacing: "normal",
      textTransform: "none"
    },
    fontFamily: "Roboto, sans-serif",
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    fontWeightBlack: 900,
    h1: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "2.5rem",
      lineHeight: "1.5em",
      letterSpacing: "normal"
    },
    h2: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "2.25rem",
      lineHeight: "1.5em",
      letterSpacing: "normal"
    },
    h3: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "2rem",
      lineHeight: "1.5em",
      letterSpacing: "normal"
    },
    h4: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "1.75rem",
      lineHeight: "1.5em",
      letterSpacing: "normal"
    },
    h5: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "1.625rem",
      lineHeight: "1.5em",
      letterSpacing: "normal"
    },
    h6: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "1.375rem",
      lineHeight: "1.5em",
      letterSpacing: "normal"
    },
    body500: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "1.25rem",
      lineHeight: "1.5em",
      letterSpacing: "normal"
    },
    body300: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: "1.5em",
      letterSpacing: "normal"
    },
    body200: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: "1.5em",
      letterSpacing: "normal"
    },
    body400: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "1.125rem",
      lineHeight: "1.5em",
      letterSpacing: "normal"
    },
    body100: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: "1.5em",
      letterSpacing: "normal"
    }
  },
  effect: {
    shadowdialog: "0px 4px 16px 0px #0000001a",
    shadowfab: {
      0: "0px 1px 18px 0px #0000001f",
      1: "0px 6px 10px 0px #00000024",
      2: "0px 3px 5px -1px #00000033"
    },
    shadowinformation: "0px 2px 4px 0px #0000001a",
    shadowmenutop: "0px -2px 8px 0px #0000001a",
    shadowmenucenter: "0px 0px 8px 0px #0000001a",
    shadowmenubottom: "0px 2px 8px 0px #0000001a",
    shadowmenuleft: "-2px 0px 8px 0px #0000001a",
    shadowmenuright: "2px 0px 8px 0px #0000001a"
  },
  text: {
    primary: "#191919ff",
    secondary: "#909090ff",
    tertiary: "#565656ff"
  },
  good: "#358600ff",
  metric: "#c0570dff",
  caution: "#be2434ff",
  marketing: "#9781e2ff",
  primaryBackground: "#ffffffff",
  primaryBorder: "#dbdbdbff"
};
export {
  f as default
};
